import React from 'react';
import SectionGridBackground from './SectionGridBackground';
import EditingWorkNote from './EditingWorkNote';
import './AboutSection.css';

const AboutSection = ({ content }) => {
  return (
    <section id="about" className="about-section section">
      <SectionGridBackground />

      <div className="section-content">
        <h2 className="section-title">{content.title}</h2>

        <div className="about-layout">
          <div className="profile-image-container">
            <img
              src="/images/profile.webp"
              alt="Andrew Freedman"
              className="profile-image"
              width={320}
              height={320}
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="about-right">
            <div className="about-text">
              <p dangerouslySetInnerHTML={{ __html: content.bio }}></p>

              <EditingWorkNote editingWork={content.editingWork} />

              <h4>{content.missionTitle}</h4>
              <p className="mission" dangerouslySetInnerHTML={{ __html: content.mission }}></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
